// Letras y ajustes finos de los carteles. Se guardan en el servidor (§7): los mismos para
// cualquier navegador. Lo que el generador viejo dejó en el navegador se borra (P-27).
import { adminFetch } from "../../api";
import { DEFAULT_PRESET, type PDFPreset } from "./generar";

const CLAVE_VIEJA = "turno_tandil_pdf_preset";

function olvidarPresetDelNavegador() {
  try {
    localStorage.removeItem(CLAVE_VIEJA);
  } catch {
    // navegador sin acceso al almacenamiento: no hay nada que borrar
  }
}

export async function cargarPreset(): Promise<PDFPreset> {
  olvidarPresetDelNavegador();
  const res = await adminFetch("/api/pdf-preset");
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return { ...DEFAULT_PRESET, ...(data?.preset ?? {}) };
}

export async function guardarPreset(preset: PDFPreset): Promise<void> {
  const res = await adminFetch("/api/pdf-preset", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ preset }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
